import React from 'react'
import './Hero.sass'
import { withRouter } from 'react-router-dom'
import Button from '../../ui/Button/Button'
import heroBg from './assets/car.jpg'

function Hero() {
  return (
    <div id="home" className="Site-Hero">
      <div
        className="HeroBg"
        style={{ backgroundImage: `url(${heroBg})` }}
      ></div>
      <div className="DefaultContainer">
        <div className="Offer">
          <h1 className="Title">Аренда автомобиля в Мурманске</h1>
          <p className="Description">
            Более 15 лет успешной работы на рынке аренды авто
          </p>

          <div className="Buttons">
            <Button
              theme="primary"
              title="Перейти к каталогу авто"
              type="navhashlink"
              icon="cars"
              iconWeight="solid"
              path="#catalog"
              size={48}
            />
          </div>
        </div>
      </div>
    </div>
  )
}

export default withRouter(Hero)
